/**
 * @flow
 * @relayHash 26838fdbfe41ae389fe42717ff3d59ea
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ToggleAssignFollowersForDeliverablesInput = {|
  userIds: $ReadOnlyArray<?string>,
  deliverableIds: $ReadOnlyArray<?string>,
  follow: boolean,
  clientMutationId?: ?string,
|};
export type ToggleAssignFollowersForDeliverablesMutationVariables = {|
  input: ToggleAssignFollowersForDeliverablesInput
|};
export type ToggleAssignFollowersForDeliverablesMutationResponse = {|
  +toggleAssignFollowersForDeliverables: ?{|
    +success: ?boolean,
    +clientMutationId: ?string,
  |}
|};
export type ToggleAssignFollowersForDeliverablesMutation = {|
  variables: ToggleAssignFollowersForDeliverablesMutationVariables,
  response: ToggleAssignFollowersForDeliverablesMutationResponse,
|};
*/

/*
mutation ToggleAssignFollowersForDeliverablesMutation(
  $input: ToggleAssignFollowersForDeliverablesInput!
) {
  toggleAssignFollowersForDeliverables(input: $input) {
    success
    clientMutationId
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'ToggleAssignFollowersForDeliverablesInput!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'toggleAssignFollowersForDeliverables',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input'
          }
        ],
        concreteType: 'ToggleAssignFollowersForDeliverablesPayload',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'success',
            args: null,
            storageKey: null
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'clientMutationId',
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'ToggleAssignFollowersForDeliverablesMutation',
      type: 'Mutation',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'ToggleAssignFollowersForDeliverablesMutation',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'mutation',
      name: 'ToggleAssignFollowersForDeliverablesMutation',
      id: null,
      text:
        'mutation ToggleAssignFollowersForDeliverablesMutation(\n  $input: ToggleAssignFollowersForDeliverablesInput!\n) {\n  toggleAssignFollowersForDeliverables(input: $input) {\n    success\n    clientMutationId\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '9940d89e9a305e4e1cbe9cc35f27ae4b';
module.exports = node;
